import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "value" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "titleStrong" }
const _hoisted_5 = { class: "display-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_loader = _resolveComponent("content-loader")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_content_loader, { class: "tile-loading" })
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        style: _normalizeStyle({ backgroundColor: `var(${_ctx.color})` }),
        class: "container container-tile"
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.value), 1),
        _createElementVNode("p", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.titleNotBold) + " ", 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.titleInBold), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.titleEnd ? ` ${_ctx.titleEnd}` : ''), 1)
        ])
      ], 4))
}